<script>
import { app } from '@/main'

import { LogWidgetShownInsuranceTechno } from '@/events'

export default {
  name: 'InsuranceTechno',
  template: '<template></template>',
  mounted() {
    LogWidgetShownInsuranceTechno()

    app.mitt.emit('insurance-module-loaded')
  },
}
</script>
